<template>
  <div class="temporary-clock">
    <div class="QR-container">
      <div class="qrcode" id="qrcode" ref="qrCodeUrl"></div>
      <div class="qr-explain">
        <p class="title">临时工打卡二维码</p>
        <p class="text">请尽快扫码以避免失效</p>
        <p>
          <el-button class="btn-blue" @click="refreshQR">刷新一下</el-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Employee from "models/employee";
const employee = new Employee();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      // url:'http://dttest.zcetms.com/'
      url: ""
    };
  },
  created() {
    modifyNetTitle('临时工打卡')
  },
  mounted() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      employee.getTempNumber().then(res => {
        if (res.success) {
          let signNumber = res.result.signNumber;
          let timeStamp = res.result.timeStamp;
          this.url = `https://kq.snl-nova.com?signNumber=${signNumber}&timeStamp=${timeStamp}`;
          this.creatQrCode();
        }
      });
    },
    creatQrCode() {
      document.getElementById("qrcode").innerHTML = "";
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.url, // 需要转换为二维码的内容
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    refreshQR() {
      this.getUrl();
    }
  }
};
</script>
<style lang="scss" scoped>
.temporary-clock {
  flex: 1;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .QR-container {
    width: 580px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .qrcode {
      width: 300px;
      height: 300px;
      background: url(../../../../assets/images/employee/QR.png) center center
        no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .qr-explain {
      padding-top: 70px;
      .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 18px;
      }
      .text {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 17px;
      }
    }
  }
}
</style>
